export default {"src":"/_next/static/media/CMCSA.50dfdd2b.svg","height":18,"width":18};